export default function empty(results) {
  return `
  <div class="search__no-results">
    <p class="search__no-results__text">No Results Found for <span class="search__no-results__text--query">${results.query}</span>.</p>
  </div>
  `;
}
